import {
  EVENT_LIST_REQUEST,
  EVENT_LIST_SUCCESS,
  EVENT_LIST_FAIL,
} from "../constants/eventConstants";
import { api2 } from "../core/api";

export const getEvents = () => async (dispatch) => {
  try {
    dispatch({
      type: EVENT_LIST_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await api2.get("/event", config);

    var dt = data.Result;

    if (typeof dt === "string") {
      dispatch({
        type: EVENT_LIST_FAIL,
        payload: dt.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: EVENT_LIST_SUCCESS,
        payload: dt,
      });
    }
  } catch (error) {
    dispatch({
      type: EVENT_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data?.message
          : error?.message,
    });
  }
};

export const getUniversityStudent =
  (UniversityId, eventId) => async (dispatch) => {
    try {
      dispatch({
        type: EVENT_LIST_REQUEST,
      });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await api2.get(
        `/universityCount/guest/university/${UniversityId}/${eventId}`,
        config
      );

      var dt = data.Result;

      if (typeof dt === "string") {
        dispatch({
          type: EVENT_LIST_FAIL,
          payload: dt.replace("Error - ", ""),
        });
      } else {
        dispatch({
          type: EVENT_LIST_SUCCESS,
          payload: dt,
        });
      }
    } catch (error) {
      // console.log(error.response?.data?.Result);
      dispatch({
        type: EVENT_LIST_FAIL,
        payload:
          error.response && error.response?.data?.Result
            ? error.response.data.Result
            : error?.message,
      });
    }
  };
